; (function (jQuery) {

	"use strict";

	function BaatSiteHeader()
	{
		var fn = {
			init: function ()
			{
				jQuery('.js-mobile-menu-toggle').on('click', fn.toggleMobileNavMenu);
			},

			toggleMobileNavMenu: function()
			{
				const navMenu = jQuery('.site-header__nav');
				const navMenuToggle = jQuery('.site-header__mobile-menu-toggle');
				const navMenuToggleText = jQuery('.site-header__mobile-menu-toggle span');

				navMenu.slideToggle(100);
				navMenu.toggleClass('is-mobile-nav-open');
				navMenuToggle.toggleClass('is-mobile-nav-open');

				// hide page content when mobile menu open
				// set toggle button text
				if (navMenuToggle.hasClass('is-mobile-nav-open'))
				{
					jQuery('main').css('display', 'none');
					navMenuToggleText.html('Close');
				}
				else
				{
					jQuery('main').css('display', 'block');
					navMenuToggleText.html('Menu');
				}

				// set toggle button 'expanded'
				navMenuToggle.attr('aria-expanded', function(i, attr)
				{
					return attr === 'false' ? 'true' : 'false';
				});
			}
		}

		jQuery(fn.init);
	}

	new BaatSiteHeader();
})(jQuery);